import type { AppDataConfig } from '@/types';
import * as v from 'valibot';
import Condition from '@/utils/condition';
import FormSchema from '@/utils/form-schema';

const appData = {
  page: 'passexperten-rightmart',
  googleLogin: false,
  dateFormatToSend: {
    bewilligungsdatum: 'YYYY-MM-DD',
  },
  externalIdGenerateMethod: 'sha1',
  iconPosition: 'after',
  cssVersion: 2,
  dontLookForSecret: true,
  header: {
    showAlert: false,
    alertMessage:
      '<b>Aktuelle Information</b>: Trotz Corona-Krise steht Ihnen unser Bescheidcheck wie gewohnt zur Verfügung.',
    alertCss: {
      background: '#eff5f4',
      color: '#302576',
    },
    info: 'Kostenlose Erstberatung',
    phone: '',
    openingTimes: '',
    enableStickyMobileHead: true,
  },
  banner: {
    title: [
      {
        condition: () => true,
        value: {
          xxxs: 'Möchten Sie eine <span style="font-weight:500;">uneingeschränkte<br>Aufenthaltserlaubnis</span> oder den <span style="font-weight:500;">deutschen Pass</span>?',
          xxs: 'Möchten Sie eine <span style="font-weight:500;">uneingeschränkte<br>Aufenthaltserlaubnis</span> oder den <span style="font-weight:500;">deutschen Pass</span>?',
          xs: 'Möchten Sie eine <span style="font-weight:500;">uneingeschränkte<br>Aufenthaltserlaubnis</span> oder den <span style="font-weight:500;">deutschen Pass</span>?',
          sm: 'Möchten Sie eine <span style="font-weight:500;">uneingeschränkte<br>Aufenthaltserlaubnis</span> oder den <span style="font-weight:500;">deutschen Pass</span>?',
          md: 'Möchten Sie eine <span style="font-weight:500;">uneingeschränkte<br>Aufenthaltserlaubnis</span> oder den <span style="font-weight:500;">deutschen Pass</span>?',
          lg: 'Möchten Sie eine <span style="font-weight:500;">uneingeschränkte<br>Aufenthaltserlaubnis</span> oder den <span style="font-weight:500;">deutschen Pass</span>?',
        },
      },
    ],
    subtitle: [
      {
        condition: () => true,
        value: 'Testen Sie jetzt, ob Sie alle Voraussetzungen erfüllen',
      },
    ],
  },
  sign: {
    withEnvelopIcon: false,
    withEmojies: false,
    titleSuccessColor: true,
    congratulation: [
      {
        condition: () => true,
        value: {
          title: 'Fast geschafft ...',
          content: 'Um Ihnen das Ergebnis der kostenlosen Prüfung mitzuteilen, benötigen wir noch Ihre Kontaktdaten:',
        },
      },
    ],
    form: {
      schema: (keys) =>
        v.object({
          salutation: FormSchema.salutation(keys, ['Herr', 'Frau', 'unknown']),
          first_name: FormSchema.firstName(keys),
          last_name: FormSchema.lastName(keys),
          email: FormSchema.email(keys),
          phone: FormSchema.phone(keys),
        }),
      layout: [
        {
          label: 'Anrede',
          cells: [
            {
              type: 'radio',
              key: 'salutation',
              choices: [
                {
                  label: 'Herr',
                  value: 'Herr',
                  isDefault: true,
                },
                {
                  label: 'Frau',
                  value: 'Frau',
                },
                {
                  label: 'Divers',
                  value: 'unknown',
                },
              ],
            },
          ],
        },
        {
          label: 'Name',
          cells: [
            {
              type: 'text',
              key: 'first_name',
              label: 'Vorname',
              placeholder: 'Vorname',
              placeholderShort: 'Vorname',
            },
            {
              type: 'text',
              key: 'last_name',
              label: 'Nachname',
              placeholder: 'Nachname',
              placeholderShort: 'Nachname',
            },
          ],
        },
        {
          label: 'E-Mail',
          cells: [
            {
              type: 'text',
              key: 'email',
              label: 'E-Mail',
              placeholder: 'z.B. max@mustermann.de',
              placeholderShort: 'z.B. max@mustermann.de',
            },
          ],
        },
        {
          label: 'Telefon',
          cells: [
            {
              type: 'text',
              key: 'phone',
              label: 'Telefon',
              placeholder: 'z.B. +49 170 000 000',
              placeholderShort: 'z.B. +49 170 000 000',
            },
          ],
        },
      ],
      button: [
        {
          condition: () => true,
          value: 'Ergebnis anfordern',
        },
      ],
    },
    certificates: {
      hints: ['Garantierter Datenschutz - 100% Kostenlos'],
      withTuv: false,
    },
  },
  article: null,
  keywordWhiteList: [],
  selectedKeywordTitle: 'rightmart.de',
  domainName: 'www.rightmart.de',
  isInternationalizationOn: false,
  prefix: [
    {
      condition: () => true,
      value: 'PEX',
    },
  ],
  switchSlidesMode: 'on-next',
  questions: [
    {
      message: "<span style='font-weight:400;'>Kostenlosen Test starten:</span>",
      title: 'Was möchten Sie erreichen?',
      key: 'q17347',
      type: 'multiple-text',
      isRoot: true,
      choices: [
        {
          value: 'Befristetes Aufenthaltsrecht',
          label: 'Befristetes Aufenthaltsrecht',
          icon: 'nein',
          path: ['kein-check'],
        },
        {
          value: 'Unbefristetes Aufenthaltsrecht / Niederlassungserlaubnis',
          label: 'Unbefristetes Aufenthaltsrecht / Niederlassungs&shyerlaubnis',
          icon: 'ja',
          path: ['tq17375'],
        },
        {
          value: 'Einbürgerung',
          label: 'Einbürgerung / deutschen Pass',
          icon: 'ja',
          path: ['q17375'],
          isPreselected: true,
        },
        {
          value: 'Familiennachzug',
          label: 'Familiennachzug',
          icon: 'nein',
          path: ['kein-check'],
        },
        {
          value: 'Sonstiges',
          label: 'Sonstiges',
          icon: 'unsicher',
          path: ['q17375'],
        },
      ],
    },
    {
      title: 'Haben Sie einen Nationalpass aus Ihrem Herkunftsland?',
      key: 'q17375',
      type: 'multiple',
      validate: {
        required: true,
        fn: (v) =>
          Condition.messages([
            Condition.isEmpty(v),
            'Beantworten Sie bitte diese Frage. Sie ist wichtig, um den Test fortzusetzen.',
          ]),
      },
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
          path: ['q17348'],
          // isDefault: true,
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          path: ['q17376'],
        },
      ],
    },
    {
      title: 'Was ist Ihre Staatsangehörigkeit?',
      key: 'q17376',
      type: 'multiple-text',
      choices: [
        {
          value: 'Afghanisch',
          label: 'Afghanisch',
          icon: 'ja',
          path: ['otherIdentificationDocument', 'q17348'],
        },
        {
          value: 'Eritreisch',
          label: 'Eritreisch',
          icon: 'ja',
          path: ['otherIdentificationDocument', 'q17348'],
        },
        {
          value: 'Somalisch',
          label: 'Somalisch',
          icon: 'ja',
          path: ['otherIdentificationDocument', 'q17348'],
        },
        {
          value: 'Syrisch',
          label: 'Syrisch',
          icon: 'ja',
          path: ['otherIdentificationDocument', 'q17348'],
        },
        {
          value: 'Anderes Land',
          label: 'Anderes Land',
          icon: 'nein',
          path: ['q17348'],
          // → Negative Dankeseite / Erinnerungsservice
          isDefault: true,
        },
      ],
    },
    {
      title: 'Haben Sie eines dieser Dokumente zur Identitätsklärung?',
      key: 'otherIdentificationDocument',
      type: 'multiple-text',
      subline:
        '* Als anderes amtliches Dokument gelten z. B. Militärausweise, Heiratsurkunden, Meldebescheinigungen, Wehrdienstunterlagen oder Schulzeugnisse.',
      choices: [
        {
          value: 'Geburtsurkunde',
          label: 'Geburtsurkunde',
          icon: 'ja',
        },
        {
          value: 'Führerschein',
          label: 'Führerschein',
          icon: 'ja',
        },
        {
          value: 'Personalausweis aus dem Heimatland',
          label: 'Personalausweis aus dem Heimatland',
          icon: 'ja',
        },
        {
          value: 'anderes amtliches Dokument mit Foto und Namen',
          label: 'Anderes amtliches Identitätsdokument',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          // → Negative Dankeseite / Erinnerungsservice
          isDefault: true,
        },
      ],
    },
    {
      title: 'Seit wann leben Sie in Deutschland?',
      key: 'q17348',
      type: 'dropdown',
      isSearchHidden: true,
      label: 'Jahr',
      placeholder: 'Wählen Sie das Jahr aus ...',
      noResult: 'Ihr Bescheidtyp wurde nicht gefunden.',
      defaultValue: 'Keine Angabe',
      choices: [
        {
          label: '2012 oder davor',
          value: '2012 oder davor',
          path: ['q17356'],
        },
        {
          label: '2013',
          value: '2013',
          path: ['q17356'],
        },
        {
          label: '2014',
          value: '2014',
          path: ['q17356'],
        },
        {
          label: '2015',
          value: '2015',
          path: ['q17356'],
        },
        {
          label: '2016',
          value: '2016',
          path: ['q17356'],
        },
        {
          label: '2017',
          value: '2017',
          path: ['q17356'],
        },
        {
          label: '2018',
          value: '2018',
          path: ['q17356'],
        },
        {
          label: '2019',
          value: '2019',
          path: ['q17356'],
        },
        {
          label: '2020',
          value: '2020',
          path: ['q17356'],
        },
        {
          label: '2021',
          value: '2021',
          path: ['q17356'],
        },
        {
          label: '2022',
          value: '2022',
          path: ['q17356'],
        },
        {
          label: '2023',
          value: '2023',
          path: ['q17356'],
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '2024',
          value: '2024',
          path: ['q17356'],
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '2025',
          value: '2025',
          path: ['q17356'],
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '2026',
          value: '2026',
          path: ['q17356'],
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: 'Keine Angabe / Unsicher',
          value: 'Keine Angabe',
          path: ['q17356'],
        },
      ],
    },
    {
      title: 'Welches Aufenthaltsrecht haben Sie aktuell?',
      key: 'q17356',
      type: 'multiple-text',
      choices: [
        {
          value: 'Befristetes Aufenthaltsrecht',
          label: 'Befristetes Aufenthaltsrecht',
          icon: 'ja',
          path: ['q17358', 'q17359'],
        },
        {
          value: 'Unbefristetes Aufenthaltsrecht',
          label: 'Unbefristetes Aufenthaltsrecht',
          icon: 'ja',
          path: ['q17361'],
        },
        {
          value: 'EU-Bürger',
          label: 'EU-Bürger',
          icon: 'ja',
          path: ['q17361'],
        },
        {
          value: 'Duldung',
          label: 'Duldung',
          icon: 'nein',
          path: ['q17361'],
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          value: 'Fiktionsbescheinigung',
          label: 'Fiktionsbescheinigung',
          icon: 'ja',
          path: ['q17358', 'q17359'],
        },
        {
          value: 'Ich weiß es nicht',
          label: 'Ich weiß es nicht',
          icon: 'unsicher',
          path: ['q17361'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Welches befristete Aufenthaltsrecht haben Sie aktuell?',
      key: 'q17358',
      type: 'dropdown',
      isSearchHidden: true,
      placeholder: 'Bitte auswählen ...',
      noResult: 'Ihr Aufenthaltsrechtstyp wurde nicht gefunden.',
      subline:
        '<div class="pex-info-container" style="max-width: 450px; font-size: 14px; line-height: 22px; background: #B5B5E3; padding: 16px; border-radius: 8px; margin: 20px auto 0;"><p style="margin-top: 0; margin-bottom: 0;">Das genaue Aufenthaltsrecht finden Sie auf Ihrer Aufenthaltskarte.</p><img src="https://passexperten.de/wp-content/uploads/2023/11/grafik-aufenthaltstitel.png" style="width: 100%; margin-top: 15px;" alt="grafik"></div>',
      defaultValue: 'Sonstiges',
      choices: [
        {
          label: '§ 4 Abs. 2',
          value: '§ 4 Abs. 2',
        },
        {
          label: '§ 5 - FreizügG/EU',
          value: '§ 5 FreizügG/EU',
        },
        {
          label: '§ 7',
          value: '§ 7',
        },
        {
          label: '§ 16a',
          value: '§ 16a',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16b',
          value: '§ 16b',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16c',
          value: '§ 16c',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16d',
          value: '§ 16d',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16e',
          value: '§ 16e',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16f',
          value: '§ 16f',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16g',
          value: '§ 16g',
        },
        {
          label: '§ 17',
          value: '§ 17',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 18a',
          value: '§ 18a',
        },
        {
          label: '§ 18b',
          value: '§ 18b',
        },
        {
          label: '§ 18c',
          value: '§ 18c',
        },
        {
          label: '§ 18d',
          value: '§ 18d',
        },
        {
          label: '§ 18e',
          value: '§ 18e',
        },
        {
          label: '§ 18f',
          value: '§ 18f',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 18g',
          value: '§ 18g',
        },
        {
          label: '§ 19',
          value: '§ 19',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 19a',
          value: '§ 19a',
        },
        {
          label: '§ 19b',
          value: '§ 19b',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 19c',
          value: '§ 19c',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 19d',
          value: '§ 19d',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 19e',
          value: '§ 19e',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 20',
          value: '§ 20',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 20 Abs. 3 Nr. 1',
          value: '§ 20 Abs. 3 Nr. 1',
        },
        {
          label: '§ 20a',
          value: '§ 20a',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 21',
          value: '§ 21',
        },
        {
          label: '§ 22',
          value: '§ 22',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 23',
          value: '§ 23',
        },
        {
          label: '§ 23a',
          value: '§ 23a',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 24',
          value: '§ 24',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25 Abs. 1',
          value: '§ 25 Abs. 1',
        },
        {
          label: '§ 25 Abs. 2 - Flüchtlingseigenschaft oder Subsidiärer Schutz',
          value: '§ 25 Abs. 2',
        },
        {
          label: '§ 25 Abs. 3 - Abschiebeverbot',
          value: '§ 25 Abs. 3',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25 Abs. 4',
          value: '§ 25 Abs. 4',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25 Abs. 4a',
          value: '§ 25 Abs. 4a',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25 Abs. 4b',
          value: '§ 25 Abs. 4b',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25 Abs. 5',
          value: '§ 25 Abs. 5',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25a',
          value: '§ 25a',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25b',
          value: '§ 25b',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 26',
          value: '§ 26',
        },
        {
          label: '§ 26 Abs. 3 S. 1',
          value: '§ 26 Abs. 3 S. 1',
        },
        {
          label: '§ 28',
          value: '§ 28',
        },
        {
          label: '§ 30',
          value: '§ 30',
        },
        {
          label: '§ 31',
          value: '§ 31',
        },
        {
          label: '§ 32',
          value: '§ 32',
        },
        {
          label: '§ 33',
          value: '§ 33',
        },
        {
          label: '§ 34',
          value: '§ 34',
        },
        {
          label: '§ 35',
          value: '§ 35',
        },
        {
          label: '§ 36',
          value: '§ 36',
        },
        {
          label: '§ 36a',
          value: '§ 36a',
        },
        {
          label: '§ 37',
          value: '§ 37',
        },
        {
          label: '§ 38',
          value: '§ 38',
        },
        {
          label: '§ 38a',
          value: '§ 38a',
        },
        {
          label: '§ 104c',
          value: '§ 104c',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: 'Sonstiges',
          value: 'Sonstiges',
        },
      ],
    },
    {
      title:
        "Haben Sie bereits einen <span style='font-weight: 300;'>Antrag auf ein unbefristetes Aufenthaltsrecht</span> gestellt?",
      key: 'q17359',
      type: 'multiple',
      choices: [
        {
          value: 'Nein, noch nicht.',
          label: 'Nein, noch nicht',
          icon: 'nein',
          path: ['q17363'],
          isDefault: true,
        },
        {
          value: 'Ja, aber leider wurde mein Antrag abgelehnt.',
          label: 'Ja, wurde leider abgelehnt',
          icon: 'ja',
          path: ['q17363'],
        },
        {
          value: 'Ja, aktuell wird der Antrag bearbeitet.',
          label: 'Ja, wird aktuell bearbeitet',
          icon: 'ja',
          path: ['q17363'],
        },
        {
          value: 'Ich weiß es nicht.',
          label: 'Ich weiß es nicht',
          icon: 'unsicher',
          path: ['q17363'],
        },
      ],
    },
    {
      title:
        "Haben Sie bereits einen <span style='font-weight: 300;'>Antrag auf Einbürgerung</span> (deutschen Pass) gestellt?",
      key: 'q17361',
      type: 'multiple',
      choices: [
        {
          value: 'Nein, noch nicht.',
          label: 'Nein, noch nicht',
          icon: 'nein',
          path: ['q17363'],
          isDefault: true,
        },
        {
          value: 'Ja, aber leider wurde mein Antrag abgelehnt.',
          label: 'Ja, wurde leider abgelehnt',
          icon: 'ja',
          path: ['q17363'],
        },
        {
          value: 'Ja, aktuell wird der Antrag bearbeitet.',
          label: 'Ja, wird aktuell bearbeitet',
          icon: 'ja',
          path: ['q17363'],
        },
        {
          value: 'Ich weiß es nicht.',
          label: 'Ich weiß es nicht',
          icon: 'unsicher',
          path: ['q17363'],
        },
      ],
    },
    {
      title: 'Arbeiten Sie derzeit in Deutschland?',
      key: 'q17363',
      type: 'multiple',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
          path: ['q8872', 'q17365', 'q18261'],
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          path: ['q18261'],
        },
        {
          value: 'Keine Angabe',
          label: 'Keine Angabe',
          icon: 'unsicher',
          path: ['q8872', 'q17365', 'q18261'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Wie hoch ist Ihr monatliches Nettoeinkommen (in Euro)?',
      key: 'q8872',
      type: 'text',
      placeholder: 'z.B. 2500',
      finalValue: '0',
      subline:
        '* Mit Nettoeinkommen ist der Betrag gemeint, der monatlich auf Ihr Konto überwiesen wird.<br>Notfalls Schätzwert eingeben',
      doFormatPrice: false,
      validate: {
        required: false,
        fn: (v: string) => {
          const isNotDigitsOnly = Condition.isDigitOnly(v);
          const isNotEmpty = !Condition.isEmpty(v);
          const isShort = Condition.isShorterLength(v, 2);
          return Condition.messages(
            [isNotEmpty && isNotDigitsOnly, 'Bitte geben Sie nur Ziffern ein.'],
            [isNotEmpty && !isNotDigitsOnly && isShort, 'Bitte geben Sie Ihr monatliches Nettoeinkommen ein.'],
          );
        },
      },
    },
    {
      title: 'Sind Sie selbstständig tätig?',
      subline: '* Eigene Firma oder Freelancer',
      key: 'q17365',
      type: 'multiple',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          path: ['q18261'],
        },
        {
          value: 'Keine Angabe',
          label: 'Keine Angabe',
          icon: 'unsicher',
          isDefault: true,
        },
      ],
    },
    {
      title: 'Erhalten Sie derzeit Bürgergeld?',
      key: 'q18261',
      type: 'multiple',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
          path: ['q17368'],
          // path: ['kein-check'],
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          path: ['q17368'],
        },
        {
          value: 'Keine Angabe',
          label: 'Keine Angabe',
          icon: 'unsicher',
          path: ['q17368'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Welchen Abschluss haben Sie in Deutschland erworben?',
      key: 'q17368',
      type: 'multiple-text',
      choices: [
        {
          value: '9. Klasse Abschluss',
          label: '9. Klasse Abschluss',
          icon: 'ja',
          path: ['q17372'],
        },
        {
          value: '10. Klasse Abschluss',
          label: '10. Klasse Abschluss',
          icon: 'ja',
          path: ['q17372'],
        },
        {
          value: 'Abitur oder Fachabitur',
          label: 'Abitur oder Fachabitur',
          icon: 'ja',
          path: ['q17372'],
        },
        {
          value: 'Ausbildung',
          label: 'Ausbildung',
          icon: 'ja',
          path: ['q17372'],
        },
        {
          value: 'Studium',
          label: 'Studium',
          icon: 'ja',
          path: ['q17372'],
        },
        {
          value: 'Nein',
          label: 'Keinen deutschen Abschluss',
          icon: 'nein',
          path: ['q17369', 'q17370', 'q17372'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Haben Sie ein deutsches Sprachzertifikat?',
      key: 'q17369',
      type: 'multiple-text',
      choices: [
        {
          value: 'A1',
          label: 'A1',
          icon: 'ja',
          path: ['q17377', 'q17370', 'q17372'],
        },
        {
          value: 'A2',
          label: 'A2',
          icon: 'ja',
          path: ['q17377', 'q17370', 'q17372'],
        },
        {
          value: 'B1',
          label: 'B1',
          icon: 'ja',
          path: ['q17370', 'q17372'],
        },
        {
          value: 'B2',
          label: 'B2',
          icon: 'ja',
          path: ['q17370', 'q17372'],
        },
        {
          value: 'C1',
          label: 'C1',
          icon: 'ja',
          path: ['q17370', 'q17372'],
        },
        {
          value: 'C2',
          label: 'C2',
          icon: 'ja',
          path: ['q17370', 'q17372'],
        },
        {
          value: 'Nein',
          label: 'Kein deutsches Sprachzertifikat',
          icon: 'nein',
          path: ['q17377', 'q17370', 'q17372'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Sind Sie vom Sprachzertifikat befreit?',
      key: 'q17377',
      type: 'multiple-text',
      choices: [
        {
          value: 'Altersbedingt - Über 60 Jahre alt',
          label: 'Ja, altersbedingt - Über 60 Jahre alt',
          icon: 'ja',
        },
        {
          value: 'Unter 16 Jahren',
          label: 'Ja, unter 16 Jahren',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          // → Negative Dankeseite / Erinnerungsservice
          isDefault: true,
        },
      ],
    },
    {
      title: 'Haben Sie einen Test "Leben in Deutschland" / Einbürgerungstest bestanden?',
      key: 'q17370',
      type: 'multiple',
      subline: '* Der Einbürgerungstest und der Test „Leben in Deutschland" sind der gleiche Test.',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
          path: ['q17372'],
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          path: ['q17378', 'q17372'],
        },
        {
          value: 'Ich weiß es nicht',
          label: 'Ich weiß es nicht',
          icon: 'unsicher',
          path: ['q17372'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Sind Sie vom Einbürgerungstest befreit?',
      key: 'q17378',
      type: 'multiple-text',
      choices: [
        {
          value: 'Höheres Alter',
          label: 'Ja, altersbedingt - Über 60 Jahre alt',
          icon: 'ja',
        },
        {
          value: 'Unter 16 Jahren',
          label: 'Ja, unter 16 Jahren',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          // → Negative Dankeseite / Erinnerungsservice
          isDefault: true,
        },
      ],
    },
    {
      title: 'Wie ist Ihr Familienstatus?',
      key: 'q17372',
      type: 'multiple-text',
      choices: [
        {
          value: 'Ledig - Ich bin nicht verheiratet.',
          label: 'Ledig, ich bin nicht verheiratet',
          icon: 'ja',
          path: ['q17373'],
        },
        {
          value: 'Verheiratet',
          label: 'Verheiratet / in einer eingetragenen Lebenspartnerschaft',
          icon: 'ja',
          path: ['q18265', 'q17374', 'q17373'],
        },
        {
          value: 'Geschieden',
          label: 'Geschieden',
          icon: 'ja',
          path: ['q17373'],
        },
        {
          value: 'Verwitwet - Mein Partner ist bereits verstorben.',
          label: 'Verwitwet',
          icon: 'ja',
          path: ['q17373'],
        },
        {
          value: 'Keine Angabe',
          label: 'Keine Angabe',
          icon: 'nein',
          path: ['q17373'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Hat Ihr Partner die deutsche Staatsangehörigkeit?',
      key: 'q18265',
      type: 'multiple',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          isDefault: true,
        },
      ],
    },
    {
      title: 'Arbeitet Ihr Partner derzeit in Deutschland?',
      key: 'q17374',
      type: 'multiple',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          isDefault: true,
        },
        {
          value: 'Ich weiß es nicht',
          label: 'Ich weiß es nicht',
          icon: 'unsicher',
        },
      ],
    },
    {
      title: 'Haben Sie Kinder?',
      key: 'q17373',
      type: 'multiple',
      choices: [
        {
          value: 'ja',
          label: 'Ja',
          icon: 'ja',
          path: ['kinderanzahl', 'formular'],
        },
        {
          value: 'nein',
          label: 'Nein',
          icon: 'nein',
          path: ['formular'],
        },
        {
          value: 'unsicher',
          label: 'Keine Angabe',
          isDefault: true,
          icon: 'unsicher',
          path: ['formular'],
        },
      ],
    },
    {
      title: 'Wie viele Kinder haben Sie?',
      key: 'kinderanzahl',
      overwrites: 'q17373',
      type: 'text',
      defaultValue: '0',
      placeholder: 'z.B. 2',
      subline: 'Bitte nur Zahlen eingeben',
    },
    {
      title: 'Warum möchten Sie in Deutschland bleiben oder einen Aufenthaltstitel beantragen?',
      key: 'tq23330',
      type: 'multiple-text',
      choices: [
        {
          value: 'Beschäftigung als Arbeitnehmer',
          label: 'Beschäftigung als Arbeitnehmer',
          icon: 'ja',
          path: ['tq17375'],
        },
        {
          value: 'Selbstständigkeit',
          label: 'Selbstständigkeit',
          icon: 'nein',
          path: ['tq17375'],
        },
        {
          value: 'Arbeitsplatzsuche',
          label: 'Arbeitsplatzsuche',
          icon: 'nein',
          path: ['tq17375'],
        },
        {
          value: 'Student',
          label: 'Student',
          icon: 'nein',
          path: ['tq17375'],
        },
        {
          value: 'Doktorand',
          label: 'Doktorand',
          icon: 'nein',
          path: ['tq17375'],
        },
        {
          value: 'Hochschulabsolvent',
          label: 'Hochschulabsolvent',
          icon: 'nein',
          path: ['tq17375'],
        },
        {
          value: 'Schulbesuch oder Sprachkurs',
          label: 'Schulbesuch oder Sprachkurs',
          icon: 'nein',
          path: ['tq17375'],
        },
        {
          value: 'Familiäre Gründe',
          label: 'Familiäre Gründe',
          icon: 'nein',
          path: ['tq17375'],
        },
        {
          value: 'Völkerrechtliche, Humanitäre oder politische Gründe',
          label: 'Völkerrechtliche, Humanitäre oder politische Gründe',
          icon: 'nein',
          path: ['tq17375'],
        },
        {
          value: 'Keine Angabe',
          label: 'Keine Angabe / Unsicher',
          icon: 'unsicher',
          path: ['tq17375'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Haben Sie einen Nationalpass aus Ihrem Herkunftsland?',
      key: 'tq17375',
      type: 'multiple',
      validate: {
        required: true,
        fn: (v) =>
          Condition.messages([
            Condition.isEmpty(v),
            'Beantworten Sie bitte diese Frage. Sie ist wichtig, um den Test fortzusetzen.',
          ]),
      },
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
          path: ['tq17348'],
          // isDefault: true,
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          path: ['tqNationality'],
        },
      ],
    },
    {
      title: 'Was ist Ihre Staatsangehörigkeit?',
      key: 'tqNationality',
      type: 'multiple-text',
      choices: [
        {
          value: 'Afghanisch',
          label: 'Afghanisch',
          icon: 'ja',
          path: ['tqOtherIdentificationDocument', 'tq17348'],
        },
        {
          value: 'Eritreisch',
          label: 'Eritreisch',
          icon: 'ja',
          path: ['tqOtherIdentificationDocument', 'tq17348'],
        },
        {
          value: 'Somalisch',
          label: 'Somalisch',
          icon: 'ja',
          path: ['tqOtherIdentificationDocument', 'tq17348'],
        },
        {
          value: 'Syrisch',
          label: 'Syrisch',
          icon: 'ja',
          path: ['tqOtherIdentificationDocument', 'tq17348'],
        },
        {
          value: 'Anderes Land',
          label: 'Anderes Land',
          icon: 'nein',
          path: ['tq17348'],
          // → Negative Dankeseite / Erinnerungsservice
          isDefault: true,
        },
      ],
    },
    {
      title: 'Haben Sie eines dieser Dokumente zur Identitätsklärung?',
      key: 'tqOtherIdentificationDocument',
      type: 'multiple-text',
      subline:
        '* Als anderes amtliches Dokument gelten z. B. Militärausweise, Heiratsurkunden, Meldebescheinigungen, Wehrdienstunterlagen oder Schulzeugnisse.',
      choices: [
        {
          value: 'Geburtsurkunde',
          label: 'Geburtsurkunde',
          icon: 'ja',
        },
        {
          value: 'Führerschein',
          label: 'Führerschein',
          icon: 'ja',
        },
        {
          value: 'Personalausweis aus dem Heimatland',
          label: 'Personalausweis aus dem Heimatland',
          icon: 'ja',
        },
        {
          value: 'anderes amtliches Dokument mit Foto und Namen',
          label: 'Anderes amtliches Identitätsdokument',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          // → Negative Dankeseite / Erinnerungsservice
          isDefault: true,
        },
      ],
    },
    {
      title: 'Seit wann leben Sie in Deutschland?',
      key: 'tq17348',
      type: 'dropdown',
      isSearchHidden: true,
      label: 'Jahr',
      placeholder: 'Wählen Sie das Jahr aus ...',
      noResult: 'Ihr Bescheidtyp wurde nicht gefunden.',
      defaultValue: 'Keine Angabe',
      choices: [
        {
          label: '2012 oder davor',
          value: '2012 oder davor',
          path: ['tq17356'],
        },
        {
          label: '2013',
          value: '2013',
          path: ['tq17356'],
        },
        {
          label: '2014',
          value: '2014',
          path: ['tq17356'],
        },
        {
          label: '2015',
          value: '2015',
          path: ['tq17356'],
        },
        {
          label: '2016',
          value: '2016',
          path: ['tq17356'],
        },
        {
          label: '2017',
          value: '2017',
          path: ['tq17356'],
        },
        {
          label: '2018',
          value: '2018',
          path: ['tq17356'],
        },
        {
          label: '2019',
          value: '2019',
          path: ['tq17356'],
        },
        {
          label: '2020',
          value: '2020',
          path: ['tq17356'],
        },
        {
          label: '2021',
          value: '2021',
          path: ['tq17356'],
        },
        {
          label: '2022',
          value: '2022',
          path: ['tq17356'],
        },
        {
          label: '2023',
          value: '2023',
          path: ['tq17356'],
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '2024',
          value: '2024',
          path: ['tq17356'],
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '2025',
          value: '2025',
          path: ['tq17356'],
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '2026',
          value: '2026',
          path: ['tq17356'],
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: 'Keine Angabe / Unsicher',
          value: 'Keine Angabe',
          path: ['tq17356'],
        },
      ],
    },
    {
      title: 'Welches Aufenthaltsrecht haben Sie aktuell?',
      key: 'tq17356',
      type: 'multiple-text',
      choices: [
        {
          value: 'Befristetes Aufenthaltsrecht',
          label: 'Befristetes Aufenthaltsrecht',
          icon: 'ja',
          path: ['tq17358', 'tq17359'],
        },
        {
          value: 'Unbefristetes Aufenthaltsrecht',
          label: 'Unbefristetes Aufenthaltsrecht',
          icon: 'ja',
          path: ['tq17361'],
        },
        {
          value: 'EU-Bürger',
          label: 'EU-Bürger',
          icon: 'ja',
          path: ['tq17361'],
        },
        {
          value: 'Duldung',
          label: 'Duldung',
          icon: 'nein',
          path: ['kein-check-duldung'],
        },
        {
          value: 'Fiktionsbescheinigung',
          label: 'Fiktionsbescheinigung',
          icon: 'ja',
          path: ['tq17358', 'tq17359'],
        },
        {
          value: 'Ich weiß es nicht',
          label: 'Ich weiß es nicht',
          icon: 'unsicher',
          path: ['tq17361'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Welches befristete Aufenthaltsrecht haben Sie aktuell?',
      key: 'tq17358',
      type: 'dropdown',
      isSearchHidden: true,
      placeholder: 'Bitte auswählen ...',
      noResult: 'Ihr Aufenthaltsrechtstyp wurde nicht gefunden.',
      subline:
        '<div class="pex-info-container" style="max-width: 450px; font-size: 14px; line-height: 22px; background: #B5B5E3; padding: 16px; border-radius: 8px; margin: 20px auto 0;"><p style="margin-top: 0; margin-bottom: 0;">Das genaue Aufenthaltsrecht finden Sie auf Ihrer Aufenthaltskarte.</p><img src="https://passexperten.de/wp-content/uploads/2023/11/grafik-aufenthaltstitel.png" style="width: 100%; margin-top: 15px;" alt="grafik"></div>',
      defaultValue: 'Sonstiges',
      choices: [
        {
          label: '§ 4 Abs. 2',
          value: '§ 4 Abs. 2',
        },
        {
          label: '§ 5 - FreizügG/EU',
          value: '§ 5 FreizügG/EU',
        },
        {
          label: '§ 7',
          value: '§ 7',
        },
        {
          label: '§ 16a',
          value: '§ 16a',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16b',
          value: '§ 16b',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16c',
          value: '§ 16c',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16d',
          value: '§ 16d',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16e',
          value: '§ 16e',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16f',
          value: '§ 16f',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 16g',
          value: '§ 16g',
        },
        {
          label: '§ 17',
          value: '§ 17',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 18a',
          value: '§ 18a',
        },
        {
          label: '§ 18b',
          value: '§ 18b',
        },
        {
          label: '§ 18c',
          value: '§ 18c',
        },
        {
          label: '§ 18d',
          value: '§ 18d',
        },
        {
          label: '§ 18e',
          value: '§ 18e',
        },
        {
          label: '§ 18f',
          value: '§ 18f',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 18g',
          value: '§ 18g',
        },
        {
          label: '§ 19',
          value: '§ 19',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 19a',
          value: '§ 19a',
        },
        {
          label: '§ 19b',
          value: '§ 19b',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 19c',
          value: '§ 19c',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 19d',
          value: '§ 19d',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 19e',
          value: '§ 19e',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 20',
          value: '§ 20',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 20 Abs. 3 Nr. 1',
          value: '§ 20 Abs. 3 Nr. 1',
        },
        {
          label: '§ 20a',
          value: '§ 20a',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 21',
          value: '§ 21',
        },
        {
          label: '§ 22',
          value: '§ 22',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 23',
          value: '§ 23',
        },
        {
          label: '§ 23a',
          value: '§ 23a',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 24',
          value: '§ 24',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25 Abs. 1',
          value: '§ 25 Abs. 1',
        },
        {
          label: '§ 25 Abs. 2 - Flüchtlingseigenschaft oder Subsidiärer Schutz',
          value: '§ 25 Abs. 2',
        },
        {
          label: '§ 25 Abs. 3 - Abschiebeverbot',
          value: '§ 25 Abs. 3',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25 Abs. 4',
          value: '§ 25 Abs. 4',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25 Abs. 4a',
          value: '§ 25 Abs. 4a',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25 Abs. 4b',
          value: '§ 25 Abs. 4b',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25 Abs. 5',
          value: '§ 25 Abs. 5',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25a',
          value: '§ 25a',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 25b',
          value: '§ 25b',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: '§ 26',
          value: '§ 26',
        },
        {
          label: '§ 26 Abs. 3 S. 1',
          value: '§ 26 Abs. 3 S. 1',
        },
        {
          label: '§ 28',
          value: '§ 28',
        },
        {
          label: '§ 30',
          value: '§ 30',
        },
        {
          label: '§ 31',
          value: '§ 31',
        },
        {
          label: '§ 32',
          value: '§ 32',
        },
        {
          label: '§ 33',
          value: '§ 33',
        },
        {
          label: '§ 34',
          value: '§ 34',
        },
        {
          label: '§ 35',
          value: '§ 35',
        },
        {
          label: '§ 36',
          value: '§ 36',
        },
        {
          label: '§ 36a',
          value: '§ 36a',
        },
        {
          label: '§ 37',
          value: '§ 37',
        },
        {
          label: '§ 38',
          value: '§ 38',
        },
        {
          label: '§ 38a',
          value: '§ 38a',
        },
        {
          label: '§ 104c',
          value: '§ 104c',
          //→ Negative Dankeseite / Erinnerungsservice
        },
        {
          label: 'Sonstiges',
          value: 'Sonstiges',
        },
      ],
    },
    {
      title:
        "Haben Sie bereits einen <span style='font-weight: 300;'>Antrag auf ein unbefristetes Aufenthaltsrecht</span> gestellt?",
      key: 'tq17359',
      type: 'multiple',
      choices: [
        {
          value: 'Nein, noch nicht.',
          label: 'Nein, noch nicht',
          icon: 'nein',
          path: ['tq17363'],
          isDefault: true,
        },
        {
          value: 'Ja, aber leider wurde mein Antrag abgelehnt.',
          label: 'Ja, wurde leider abgelehnt',
          icon: 'ja',
          path: ['tq17363'],
        },
        {
          value: 'Ja, aktuell wird der Antrag bearbeitet.',
          label: 'Ja, wird aktuell bearbeitet',
          icon: 'ja',
          path: ['tq17363'],
        },
        {
          value: 'Ich weiß es nicht.',
          label: 'Ich weiß es nicht',
          icon: 'unsicher',
          path: ['tq17363'],
        },
      ],
    },
    {
      title:
        "Haben Sie bereits einen <span style='font-weight: 300;'>Antrag auf Einbürgerung</span> (deutschen Pass) gestellt?",
      key: 'tq17361',
      type: 'multiple',
      choices: [
        {
          value: 'Nein, noch nicht.',
          label: 'Nein, noch nicht',
          icon: 'nein',
          path: ['tq17363'],
          isDefault: true,
        },
        {
          value: 'Ja, aber leider wurde mein Antrag abgelehnt.',
          label: 'Ja, wurde leider abgelehnt',
          icon: 'ja',
          path: ['tq17363'],
        },
        {
          value: 'Ja, aktuell wird der Antrag bearbeitet.',
          label: 'Ja, wird aktuell bearbeitet',
          icon: 'ja',
          path: ['tq17363'],
        },
        {
          value: 'Ich weiß es nicht.',
          label: 'Ich weiß es nicht',
          icon: 'unsicher',
          path: ['tq17363'],
        },
      ],
    },
    {
      title: 'Arbeiten Sie derzeit in Deutschland?',
      key: 'tq17363',
      type: 'multiple',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
          path: ['tq8872', 'tq17365', 'tq18261'],
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          path: ['tq18261'],
        },
        {
          value: 'Keine Angabe',
          label: 'Keine Angabe',
          icon: 'unsicher',
          path: ['tq8872', 'tq17365', 'tq18261'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Wie hoch ist Ihr monatliches Nettoeinkommen (in Euro)?',
      key: 'tq8872',
      type: 'text',
      placeholder: 'z.B. 2500',
      finalValue: '0',
      subline:
        '* Mit Nettoeinkommen ist der Betrag gemeint, der monatlich auf Ihr Konto überwiesen wird.<br>Notfalls Schätzwert eingeben',
      doFormatPrice: false,
      validate: {
        required: false,
        fn: (v: string) => {
          const isNotDigitsOnly = Condition.isDigitOnly(v);
          const isNotEmpty = !Condition.isEmpty(v);
          const isShort = Condition.isShorterLength(v, 2);
          return Condition.messages(
            [isNotEmpty && isNotDigitsOnly, 'Bitte geben Sie nur Ziffern ein.'],
            [isNotEmpty && !isNotDigitsOnly && isShort, 'Bitte geben Sie Ihr monatliches Nettoeinkommen ein.'],
          );
        },
      },
    },
    {
      title: 'Sind Sie selbstständig tätig?',
      subline: '* Eigene Firma oder Freelancer',
      key: 'tq17365',
      type: 'multiple',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          path: ['tq18261'],
        },
        {
          value: 'Keine Angabe',
          label: 'Keine Angabe',
          icon: 'unsicher',
          isDefault: true,
        },
      ],
    },
    {
      title: 'Erhalten Sie derzeit Bürgergeld?',
      key: 'tq18261',
      type: 'multiple',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
          path: ['kein-check'],
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          path: ['tq17368'],
        },
        {
          value: 'Keine Angabe',
          label: 'Keine Angabe',
          icon: 'unsicher',
          path: ['tq17368'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Welchen Abschluss haben Sie in Deutschland erworben?',
      key: 'tq17368',
      type: 'multiple-text',
      choices: [
        {
          value: '9. Klasse Abschluss',
          label: '9. Klasse Abschluss',
          icon: 'ja',
          path: ['tq17372'],
        },
        {
          value: '10. Klasse Abschluss',
          label: '10. Klasse Abschluss',
          icon: 'ja',
          path: ['tq17372'],
        },
        {
          value: 'Abitur oder Fachabitur',
          label: 'Abitur oder Fachabitur',
          icon: 'ja',
          path: ['tq17372'],
        },
        {
          value: 'Ausbildung',
          label: 'Ausbildung',
          icon: 'ja',
          path: ['tq17372'],
        },
        {
          value: 'Studium',
          label: 'Studium',
          icon: 'ja',
          path: ['tq17372'],
        },
        {
          value: 'Nein',
          label: 'Keinen deutschen Abschluss',
          icon: 'nein',
          path: ['tq17369', 'tq17370', 'tq17372'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Haben Sie ein deutsches Sprachzertifikat?',
      key: 'tq17369',
      type: 'multiple-text',
      choices: [
        {
          value: 'A1',
          label: 'A1',
          icon: 'ja',
          path: ['tqExceptionsLanguageTest', 'tq17370', 'tq17372'],
        },
        {
          value: 'A2',
          label: 'A2',
          icon: 'ja',
          path: ['tqExceptionsLanguageTest', 'tq17370', 'tq17372'],
        },
        {
          value: 'B1',
          label: 'B1',
          icon: 'ja',
          path: ['tq17370', 'tq17372'],
        },
        {
          value: 'B2',
          label: 'B2',
          icon: 'ja',
          path: ['tq17370', 'tq17372'],
        },
        {
          value: 'C1',
          label: 'C1',
          icon: 'ja',
          path: ['tq17370', 'tq17372'],
        },
        {
          value: 'C2',
          label: 'C2',
          icon: 'ja',
          path: ['tq17370', 'tq17372'],
        },
        {
          value: 'Nein',
          label: 'Kein deutsches Sprachzertifikat',
          icon: 'nein',
          path: ['tqExceptionsLanguageTest', 'tq17370', 'tq17372'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Sind Sie vom Sprachzertifikat befreit?',
      key: 'tqExceptionsLanguageTest',
      type: 'multiple-text',
      choices: [
        {
          value: 'Altersbedingt - Über 60 Jahre alt',
          label: 'Ja, altersbedingt - Über 60 Jahre alt',
          icon: 'ja',
        },
        {
          value: 'Unter 16 Jahren',
          label: 'Ja, unter 16 Jahren',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          // → Negative Dankeseite / Erinnerungsservice
          isDefault: true,
        },
      ],
    },
    {
      title: 'Haben Sie einen Test "Leben in Deutschland" / Einbürgerungstest bestanden?',
      key: 'tq17370',
      type: 'multiple',
      subline: '* Der Einbürgerungstest und der Test „Leben in Deutschland" sind der gleiche Test.',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
          path: ['tq17372'],
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          path: ['tqExceptionsNaturalizationTest', 'tq17372'],
        },
        {
          value: 'Ich weiß es nicht',
          label: 'Ich weiß es nicht',
          icon: 'unsicher',
          path: ['tq17372'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Sind Sie vom Einbürgerungstest befreit?',
      key: 'tqExceptionsNaturalizationTest',
      type: 'multiple-text',
      choices: [
        {
          value: 'Höheres Alter',
          label: 'Ja, altersbedingt - Über 60 Jahre alt',
          icon: 'ja',
        },
        {
          value: 'Unter 16 Jahren',
          label: 'Ja, unter 16 Jahren',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          // → Negative Dankeseite / Erinnerungsservice
          isDefault: true,
        },
      ],
    },
    {
      title: 'Wie ist Ihr Familienstatus?',
      key: 'tq17372',
      type: 'multiple-text',
      choices: [
        {
          value: 'Ledig - Ich bin nicht verheiratet.',
          label: 'Ledig, ich bin nicht verheiratet',
          icon: 'ja',
          path: ['tq17373'],
        },
        {
          value: 'Verheiratet',
          label: 'Verheiratet / in einer eingetragenen Lebenspartnerschaft',
          icon: 'ja',
          path: ['tq18265', 'tq17374', 'tq17373'],
        },
        {
          value: 'Geschieden',
          label: 'Geschieden',
          icon: 'ja',
          path: ['tq17373'],
        },
        {
          value: 'Verwitwet - Mein Partner ist bereits verstorben.',
          label: 'Verwitwet',
          icon: 'ja',
          path: ['tq17373'],
        },
        {
          value: 'Keine Angabe',
          label: 'Keine Angabe',
          icon: 'nein',
          path: ['tq17373'],
          isDefault: true,
        },
      ],
    },
    {
      title: 'Hat Ihr Partner die deutsche Staatsangehörigkeit?',
      key: 'tq18265',
      type: 'multiple',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          isDefault: true,
        },
      ],
    },
    {
      title: 'Arbeitet Ihr Partner derzeit in Deutschland?',
      key: 'tq17374',
      type: 'multiple',
      choices: [
        {
          value: 'Ja',
          label: 'Ja',
          icon: 'ja',
        },
        {
          value: 'Nein',
          label: 'Nein',
          icon: 'nein',
          isDefault: true,
        },
        {
          value: 'Ich weiß es nicht',
          label: 'Ich weiß es nicht',
          icon: 'unsicher',
        },
      ],
    },
    {
      title: 'Haben Sie Kinder?',
      key: 'tq17373',
      type: 'multiple',
      choices: [
        {
          value: 'ja',
          label: 'Ja',
          icon: 'ja',
          path: ['tkinderanzahl', 'formular'],
        },
        {
          value: 'nein',
          label: 'Nein',
          icon: 'nein',
          path: ['formular'],
        },
        {
          value: 'unsicher',
          label: 'Keine Angabe',
          isDefault: true,
          icon: 'unsicher',
          path: ['formular'],
        },
      ],
    },
    {
      title: 'Wie viele Kinder haben Sie?',
      key: 'tkinderanzahl',
      overwrites: 'tq17373',
      type: 'text',
      defaultValue: '0',
      placeholder: 'z.B. 2',
      subline: 'Bitte nur Zahlen eingeben',
    },
    {
      title: '',
      key: 'kein-check',
      label: 'kein-check',
      type: 'paragraph',
      disableButtons: ['next'],
      defaultValue: '0',
      content:
        '<div style="margin-top:-30px;"><h2>Keine Hilfe möglich</h2><p>Leider können wir bei der spezifischen Anfrage zur Zeit nicht beraten.</p><p>Wir bedauern, Sie in der Angelegenheit nicht unterstützen zu können - stehen Ihnen jedoch gerne bei weiteren Anliegen zur Verfügung.</p></div>',
    },
    {
      title: '',
      key: 'kein-check-duldung',
      type: 'paragraph',
      disableButtons: ['next'],
      defaultValue: '0',
      content:
        '<div style="margin-top:-30px;"><h2>Mit einer Duldung gibt es leider keine Einbürgerung oder Niederlassungserlaubnis</h2><p>Wenn Sie aktuell eine Duldung haben, sollten Sie Ihren Aufenthaltsstatus so schnell wie möglich ändern. Warum? Weil sowohl für die Niederlassungserlaubnis als auch für die Einbürgerung eine gewisse Zeit in Deutschland erforderlich ist. Und hier ist der Haken: Die Zeit, in der Sie eine Duldung haben, zählt nicht in diesen Zeitraum hinein.</p></div>',
    },
    {
      title: 'Bitte geben Sie Ihre Postleitzahl ein:',
      key: 'zip',
      type: 'text',
      defaultValue: '',
      placeholder: 'z.B. 12345',
      subline: '5-stellige Postleitzahl Ihres Wohnsitzes',
    },
    {
      title: '',
      key: 'formular',
      type: 'submission',
    },
  ],
  resultPage: {
    success: () => (
      <>
        <h3 className='h3'>Vielen Dank. Das sieht gut aus!</h3>
        <h4 className='h4'>Gleich erhalten Sie Ihr Ergebnis.</h4>
        <p className='p'>Ihr Anliegen ist uns wichtig, daher werden wir Ihre Anfrage umgehend bearbeiten.</p>
        <p className='p'>
          Ein Experte wird sich zeitnah telefonisch bei Ihnen melden, Ihnen sagen, ob die Chancen für Sie gut stehen und
          alle weiteren Schritte mit Ihnen besprechen. Und das Beste:{' '}
          <strong className='strong'>Das Gespräch ist völlig kostenlos!</strong>
        </p>
        <p className='p'>
          Mit freundlichen Grüßen
          <br />
          Ihr Team von rightmart
        </p>
      </>
    ),
    failure: () => (
      <>
        <h3 className='h3'>OH NEIN!! Irgendwas ist schief gelaufen!</h3>
        <p className='p'>
          Rufen Sie uns bitte unter der 0421 / 33 100 311 an oder schreiben Sie uns eine E-Mail an
          <a className='a' href='mailto:info@rightmart.de'>
            info@rightmart.de
          </a>
          , damit wir Ihnen weiterhelfen können.
        </p>
      </>
    ),
  },
  additionalQuestions: {
    show: true,
    postAfterEach: true,
    header: () => (
      <>
        <h1>Fast geschafft ...</h1>
        <p>Um Ihnen eine präzisere Bewertung geben zu können, benötigen wir noch folgende Informationen:</p>
      </>
    ),
    main: [
      {
        isRoot: true,
        path: ['readinessForLawyer', 'leadReferrerChannel', 'userAddress'],
        type: 'radio',
        title: () => <>Bis wann benötigen Sie die Einbürgerung?</>,
        key: 'urgency',
        orientation: 'column',
        choices: [
          {
            label: 'So schnell wie möglich',
            value: 'So schnell wie möglich',
          },
          {
            label: 'Innerhalb von einem Jahr',
            value: 'Innerhalb von einem Jahr',
          },
          {
            label: 'Innerhalb der nächsten zwei Jahre',
            value: 'Innerhalb der nächsten zwei Jahre',
          },
          {
            label: 'Ich habe es nicht eilig',
            value: 'Ich habe es nicht eilig',
          },
        ],
      },
      {
        type: 'radio',
        title: () => (
          <>
            Möchten Sie die Hilfe eines Anwalts in Anspruch nehmen, um Ihre Einbürgerung zu beschleunigen und Fehler zu
            vermeiden?
          </>
        ),
        key: 'readinessForLawyer',
        orientation: 'column',
        choices: [
          {
            label: 'Ja',
            value: 'Ja',
          },
          {
            label: 'Nein',
            value: 'Nein',
          },
          {
            label: 'Es kommt auf den Preis an',
            value: 'Es kommt auf den Preis an',
          },
        ],
      },
      {
        type: 'radio',
        title: () => <>Wie sind Sie auf uns aufmerksam geworden?</>,
        key: 'leadReferrerChannel',
        orientation: 'column',
        choices: [
          {
            label: 'Empfehlung',
            value: 'Empfehlung',
          },
          {
            label: 'Suche im Internet',
            value: 'Suche im Internet',
          },
          {
            label: 'Social Media',
            value: 'Social Media',
          },
          {
            label: 'Presse',
            value: 'Presse',
          },
          {
            label: 'YouTube',
            value: 'YouTube',
          },
          {
            label: 'Podcast',
            value: 'Podcast',
          },
          {
            label: 'Plakat',
            value: 'Plakat',
          },
          {
            label: 'Newsletter',
            value: 'Newsletter',
          },
          {
            label: 'Veranstaltung',
            value: 'Veranstaltung',
          },
          {
            label: 'Rechtsschutzversicherung',
            value: 'Rechtsschutzversicherung',
          },
          {
            label: 'Keine Angabe',
            value: 'Keine Angabe',
          },
        ],
      },
      {
        type: 'form',
        title: () => <>Ihre Adresse</>,
        key: 'userAddress',
        isRequired: true,
        requiredMessage: 'Geben Sie bitte Ihre Adresse an.',
        schema: [
          [
            {
              key: 'street',
              width: 70,
              placeholder: 'Straße',
              type: 'text',
              validate: (v) => v !== '',
            },
            {
              key: 'streetNumber',
              width: 30,
              placeholder: 'Hausnr.',
              type: 'text',
              validate: (v) => v !== '',
            },
          ],
          [
            {
              key: 'zipCode',
              width: 30,
              placeholder: 'PLZ',
              type: 'text',
              validate: (v) => typeof v === 'string' && v.length === 5 && /^\d+$/.test(v),
            },
            {
              key: 'city',
              width: 70,
              placeholder: 'Stadt',
              type: 'text',
              validate: (v) => v !== '',
            },
          ],
        ],
      },
    ],
  },
  certificateLogos: ['tls'],
  showPriceModal: 0,
  showPriceModalInsuranceCondition: {},
  appendPoaToCTA: false,
  via: 'L1 Funnel - rightmart-ALR - v2',
  statics: {
    agb_version: 'einwilligung-20190617',
  },
  newClientPercentToShow: 0,
  useDynamicLandingPage: true,
  dynamicLandingPageVersion: 24,
  percentDynamicLandingPageOnPrioInsideOfficeHours: [0, 0, 0, 1],
  percentDynamicLandingPageOnPrioOutSideOfficeHours: [0, 0, 0, 1],
  openHours: ['00:00-00:00', '05:00-20:00', '05:00-20:00', '05:00-20:00', '05:00-20:00', '05:00-20:00', '05:00-17:30'],
  callDelayMinutes: 1,
  useAlternateSuccessPage: false,
  alternateSuccessPageVersion: 19,
  useInsoPriceRandomizer: false,
  insoPriceVariations: null,
  insoPriceDefault: '',
  useThanksPageWithCalculation: false,
  calculationPageUrlName: '',
  fidMapping: null,
  enableUploadFiles: false,
  redirectToOnSubmit: '',
  vollmachtApiUrl: 'https://api.jobcenter-bescheid-check.de/api/files',
  usePrioCalculatorV3: 0,
  usePrioCalculatorV2: 0,
  footerDomainName: '',
  onSuccessPhpResolve: null,
} satisfies AppDataConfig as AppDataConfig;

export default appData;
